<template>
    <a :href="url">
        <el-row :gutter="2">
            <el-col :span="15">
                <Title :title="title"></Title>
                <From :source="source" :createTime="createTime"></From>
            </el-col>
            <el-col :span="9">
                <Image1 v-lazy="image"
                        scale="16:9">
                </Image1>
            </el-col>
        </el-row>
    </a>
</template>

<script>
import Title from "./title";
import From from "./from";
import Image1 from "../image";
export default {
    name: "LeftTitleRightImage",
    components: {
        Title,
        Image1,
        From
    },
    props: {
        url: String,
        title: String,
        image: String,
        source: String,
        createTime: Number 
    }
}
</script>

<style scoped>
</style>
